(function () {
  'use strict';

  const stickyBar = document.querySelector('[data-sticky-atc]');
  const anchor = document.querySelector('[data-sticky-atc-anchor]');
  const stickyBtn = document.querySelector('[data-sticky-atc-btn]');
  const stickyPrice = document.querySelector('[data-sticky-atc-price]');
  const stickyLabel = document.querySelector('[data-sticky-atc-label]');
  const productForm = document.querySelector('form[action*="/cart/add"]');

  if (!stickyBar || !anchor || !stickyBtn || !productForm) return;

  stickyBar.removeAttribute('hidden');

  // Show after main button scrolls out of view (Task 2 spec)
  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.setAttribute('data-visible', visible ? 'true' : 'false');
      });
    },
    { threshold: 0, rootMargin: '0px 0px 0px 0px' }
  );
  observer.observe(anchor);

  stickyBtn.addEventListener('click', function () {
    if (stickyBtn.getAttribute('aria-disabled') === 'true') return;
    if (anchor) {
      if (typeof productForm.requestSubmit === 'function') {
        productForm.requestSubmit(anchor);
      } else {
        anchor.click();
      }
    }
  });

  document.addEventListener('variant:change', function (e) {
    updateStickyState(e.detail && e.detail.variant);
  });

  const variantInput = productForm.querySelector('[name="id"]');
  if (variantInput) {
    new MutationObserver(function () {
      const variantId = variantInput.value;
      if (window.productData && window.productData.variants) {
        const variant = window.productData.variants.find(function (v) {
          return String(v.id) === String(variantId);
        });
        if (variant) updateStickyState(variant);
      }
    }).observe(variantInput, { attributes: true, attributeFilter: ['value'] });

    variantInput.addEventListener('change', function () {
      syncFromVariantId(variantInput.value);
    });

    syncFromVariantId(variantInput.value);
  }

  function syncFromVariantId(variantId) {
    if (!variantId || !window.productData || !window.productData.variants) return;
    const variant = window.productData.variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (variant) updateStickyState(variant);
  }

  function updateStickyState(variant) {
    if (!variant) return;
    if (stickyPrice && variant.price != null) {
      stickyPrice.textContent = formatMoney(variant.price);
    }
    if (variant.available) {
      stickyBtn.removeAttribute('aria-disabled');
      stickyBtn.disabled = false;
      if (stickyLabel) stickyLabel.textContent = 'Add to cart';
    } else {
      stickyBtn.setAttribute('aria-disabled', 'true');
      stickyBtn.disabled = true;
      if (stickyLabel) stickyLabel.textContent = 'Sold out';
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt =
        (window.DT_THEME && window.DT_THEME.moneyFormat) ||
        (window.Shopify && window.Shopify.money_format) ||
        '${{amount}}';
      return window.Shopify.formatMoney(cents, fmt);
    }
    return '£' + (cents / 100).toFixed(2);
  }
})();
